import { UserInfo } from '@cartwhl/common/types';
import Avatar from '@cartwhl/ui/atoms/Avatar';
import Text from '@cartwhl/ui/base/TextNew';

export default function UserDetails({
  userInfo,
  loading = false,
}: {
  userInfo: UserInfo;
  loading?: boolean;
}) {
  if (loading) {
    return (
      <div className="flex animate-pulse flex-col items-center gap-4 md:flex-row">
        <div className="bg-gray-30 dark:bg-gray-60 h-14 w-14 rounded-full" />
        <div className="flex flex-col items-center justify-center gap-1">
          <div className="bg-gray-30 dark:bg-gray-60 h-5 w-32 rounded" />
          <div className="bg-gray-30 dark:bg-gray-60 h-5 w-48 rounded" />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center gap-4 md:flex-row">
      <Avatar userInfo={userInfo} size={14} />
      <div className="flex flex-col items-center justify-center gap-2 md:items-start">
        <Text as="h2" token="display/20/medium">
          {userInfo.firstName} {userInfo.lastName}
        </Text>
        <Text as="p" token="14" className="text-tertiary">
          {userInfo.email}
        </Text>
      </div>
    </div>
  );
}
